module.exports = __webpack_public_path__ + "static/img/status-tratativas.57da1ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/status-tratativas.png
// module id = TSS4
// module chunks = 1